import { LANDSCAPE_COVERAGE_IMG, LANDSCAPE_BENEFITS_IMG } from '../../data/parasHomeData';

function LandscapeBenefitIcon({ type }) {
  const common = { viewBox: "0 0 24 24", "aria-hidden": "true" };

  switch (type) {
    case "cost":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M8.5 7h7" />
          <path d="M8.5 10h7" />
          <path d="M10 7h2.4c2 0 3.1 1 3.1 2.5S14.3 12 12.3 12H10l5 5" />
          <path d="M16.5 16.5 19 19" />
          <path d="m19 16.5-2.5 2.5" />
        </svg>
      );
    case "coverage":
      return (
        <svg {...common}>
          <path d="M4 10V5h5" />
          <path d="M20 10V5h-5" />
          <path d="M4 14v5h5" />
          <path d="M20 14v5h-5" />
          <path d="M8 12h8" />
          <path d="M12 8v8" />
        </svg>
      );
    case "green":
      return (
        <svg {...common}>
          <path d="M12 20v-7" />
          <path d="M12 13c0-3.9 3.1-7 7-7 0 3.9-3.1 7-7 7Z" />
          <path d="M12 16c0-3.3-2.7-6-6-6 0 3.3 2.7 6 6 6Z" />
          <path d="M5 20h14" />
        </svg>
      );
    case "organic":
      return (
        <svg {...common}>
          <path d="M7 20c7.5-.8 11-5.2 12-14-8.8 1-13.2 4.5-14 12" />
          <path d="M5 18c2.5-2.8 5.2-4.8 8.5-6.2" />
          <path d="M5 5v3" />
          <path d="M3.5 6.5h3" />
          <path d="M18 16v3" />
          <path d="M16.5 17.5h3" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8" />
        </svg>
      );
  }
}

export default function LandscapingSection() {
  const benefits = [
    { icon: "cost", title: "Reduced Costs", desc: "" },
    { icon: "coverage", title: "Highly Scalable Coverage", desc: "" },
    { icon: "green", title: "Lush, Healthy Green Spaces", desc: "" },
    { icon: "organic", title: "Cleaner Organic Maintenance", desc: "" },
  ];
  return (
    <>
      <section className="section landscape-section" id="landscaping" aria-label="Landscaping solutions">
        <div className="landscape-inner">
          <div className="landscape-split">
            <div className="landscape-copy">
              <span className="section-label">For Landscaping Businesses</span>
              <h3 className="landscape-feature-title">Maximum Coverage Minimum Cost</h3>
              <p>A small quantity of Paras Organics goes a surprisingly long way, helping landscapers and property managers keep quality high and costs low.</p>
              <div className="landscape-table-wrap">
                <table className="landscape-table" aria-label="Landscaping coverage formula">
                  <thead>
                    <tr>
                      <th>Area</th>
                      <th>Vermicompost</th>
                      <th>Vermiwash</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>100 sq feet</td>
                      <td>1 kg</td>
                      <td>1 ltr</td>
                    </tr>
                    <tr>
                      <td>100 sq yard / var</td>
                      <td>5.5 kg</td>
                      <td>5.5 ltr</td>
                    </tr>
                    <tr>
                      <td>100 sq meter</td>
                      <td>6.5 kg</td>
                      <td>6.5 ltr</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="landscape-note">Simple ratios make it easier to quote jobs, plan procurement, and scale landscape maintenance with confidence.</div>
            </div>
            <div className="landscape-image-panel">
              <img src={LANDSCAPE_COVERAGE_IMG} alt="Large landscaped green area showing wide product coverage" />
              <div className="landscape-image-badge">
                <strong>100</strong>
                <span>Sq yard base</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section landscape-benefits-section" aria-label="Scalable landscaping benefits">
        <div className="landscape-inner">
          <div className="landscape-split">
            <div className="landscape-image-panel">
              <img src={LANDSCAPE_BENEFITS_IMG} alt="Professional landscaping with healthy plants and maintained outdoor space" />
            </div>
            <div className="landscape-copy">
              <span className="landscape-mini-label">Business Benefits</span>
              <h3 className="landscape-feature-title">Built for <span className="accent">Scalable Landscaping</span></h3>
              <p>For recurring maintenance work, what matters is predictable usage, easier costing, and healthy results across larger sites. Paras Organics supports that operating rhythm.</p>
              <div className="landscape-benefits">
                {benefits.map((b, i) => (
                  <div key={i} className="landscape-benefit-item">
                    <div className="lbi-icon">
                      <LandscapeBenefitIcon type={b.icon} />
                    </div>
                    <div>
                      <div className="lbi-title">{b.title}</div>
                      <div className="lbi-desc">{b.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{marginTop:'2rem'}}>
                <a href="/contact" className="btn-primary">Contact Us for Bulk Pricing -></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
